import {Severity, TagItem} from '@shared/components/tag-list.component';
import {isString} from 'lodash-es';

export type Severities = SeveritySelectItem[];

export interface SeveritySelectItem {
    severity: Severity;
    values: string | string[];
}

export class TagListBuilder {
    public tags: TagItem[] = [];

    add(object: any, severity: Severity | Severities = 'primary') {
        if (object) {
            this.addItem(severity, object);
        }

        return this;
    }

    addIf(exp: any, name: string, severity: Severity | Severities = 'primary') {
        if (exp) {
            this.addItem(severity, name);
        }

        return this;
    }

    private addItem(severity: Severity | SeveritySelectItem[], label: any) {
        if (isString(severity)) {
            this.tags.push({name: label.toString(), severity});
        } else {
            const result = (severity as Severities).find((ssi) => {
                return [...ssi.values].includes(label);
            })?.severity ?? 'primary';

            this.tags.push({name: label.toString(), severity: result});
        }
    }

    build() {
        return this.tags;
    }
}

const c = [
    {label: 'FACE', cond: []}
];
